// ### LoginIframe
//
// Watches Adobe's iframe-login window.

'use strict';

var App = require('./app');
var _logger = require('./logger');
var SimpleEmitter = require('./emitter');
var _ = require('./vendor/underscore');
var Dom = require('./dom');


var backdropId = 'mvpdbackdrop';
var iframeContainerId = 'mvpddiv';
var iframeId = App.ADOBE_IFRAME_NAME;

var isOpened = false;

var backdropEl = null;
var iframeContainerEl = null;
var iframeEl = null;
var closeButtonEl = null;

var backdropDefaultStyle = {
	position: 'fixed',
	top: '0px',
	left: '0px',
	backgroundColor: '#000',
	width: '100%',
	height: '100%',
	opacity: '0.4',
	zIndex: '2999',
	filter: 'alpha(opacity=40)'
};
var iframeContainerDefaultStyle = {
	position: 'absolute',
	top: '50px',
	margin: '0',
	backgroundColor: 'white',
	borderRadius: '4px',
	boxShadow: '4px 4px 8px #111',
	zIndex: '3000'
};
var iframeDefaultStyle = {
	frameborder: '0',
	border: '0'
};
var closeButtonDefaultStyle = {
	backgroundImage: 'url("http://z.cdn.turner.com/xslo/cvp/js/cvp.auth/close.png")',
	backgroundRepeat: 'no-repeat',
	zIndex: '3001',
	position: 'absolute',
	top: '3px',
	right: '3px',
	width: '54px',
	height: '14px',
	cursor: 'pointer'
};

var recenterIFrameContainer;
var debouncedRecenter;

function createRecenterFn(el) {
	return _.bind(Dom.center, Dom, el);
}

var dimensionStyle = {};

function createDimensionStyle(widthStr, heightStr) {
	return {
		width: widthStr + 'px',
		height: heightStr + 'px'
	};
}

var emitter = new SimpleEmitter();

function create(config, options) {

	// provide string versions for html/css/data usage
	if (options.width && options.height) {
		dimensionStyle = createDimensionStyle(options.width.toString(), options.height.toString());
	}

	// create back drop
	backdropEl = Dom.id(backdropId);

	if (backdropEl) {
		_logger.debug('LoginIframe', 'Unexpected presence of DOM element with ID "' + backdropId + '".');
	} else {
		backdropEl = Dom.create('div');
		Dom.attr(backdropEl, 'id', backdropId);
		_.extend(backdropEl.style, backdropDefaultStyle);
		Dom.append(backdropEl);
	}
	backdropEl.onclick = null;
	Dom.show(backdropEl);

	// create iframe container
	iframeContainerEl = Dom.id(iframeContainerId);

	if (iframeContainerEl) {
		_logger.debug('LoginIframe', 'Unexpected presence of DOM element with ID "' + iframeContainerId + '".');
	} else {
		iframeContainerEl = Dom.create('div');
		Dom.attr(iframeContainerEl, 'id', iframeContainerId);

		if (_.isString(config.iframeStyleOverride)) {
			iframeContainerEl.className = config.iframeStyleOverride;
		} else {
			_.extend(iframeContainerEl.style, iframeContainerDefaultStyle, dimensionStyle);
		}

		Dom.hide(iframeContainerEl);

		recenterIFrameContainer = createRecenterFn(iframeContainerEl);
		debouncedRecenter = _.debounce(recenterIFrameContainer, 250);

		// start watching for reasons to re-center iframe container
		Dom.on(window, 'resize', debouncedRecenter);
		Dom.on(window, 'orientationchange', debouncedRecenter);

		// create iframe
		iframeEl = Dom.id(iframeId);

		if (iframeEl) {
			_logger.debug('LoginIframe', 'Unexpected presence of DOM element with ID "' + iframeId + '".');
		} else {
			iframeEl = Dom.create('iframe');
			_.extend(iframeEl.style, iframeDefaultStyle, dimensionStyle);
			iframeEl.name = iframeId;
			iframeEl.id = iframeId;
			iframeEl.scrolling = 'no';
			Dom.append(iframeEl, iframeContainerEl);
		}

		// create close button
		closeButtonEl = Dom.create('span');

		if (_.isString(config.closeButtonStyleOverride)) {
			closeButtonEl.className = config.closeButtonStyleOverride;
		} else {
			_.extend(closeButtonEl.style, closeButtonDefaultStyle);
		}

		closeButtonEl.onclick = emitter.close;
		Dom.append(closeButtonEl, iframeContainerEl);

		// Add to body.
		Dom.append(iframeContainerEl);

		// Force the name into the DOM since it is still not refreshed, for IE.
		try {
			window.frames[iframeId].name = iframeId;
		} catch (e) {
			_logger.debug('LoginIframe', 'Failed to force the name of the "' + iframeId + '" iframe into the DOM.');
		}
	}

}

function destroy() {
	if (backdropEl) {
		Dom.remove(backdropEl);
		backdropEl = null;
	}
	if (closeButtonEl) {
		closeButtonEl.onclick = null;
		Dom.remove(closeButtonEl);
		closeButtonEl = null;
	}
	if (iframeEl) {
		Dom.remove(iframeEl);
		iframeEl = null;
		try {
			// kill reference Adobe uses from Firefox [Bug 170799]
			delete window.frames[iframeId];
		} catch (e) {}
	}
	if (iframeContainerEl) {
		Dom.remove(iframeContainerEl);
		iframeContainerEl = null;
	}

	if (debouncedRecenter) {
		Dom.off(window, 'resize', debouncedRecenter);
		Dom.off(window, 'orientationchange', debouncedRecenter);
		debouncedRecenter = null;
	}

	recenterIFrameContainer = null;
}

function open(config, options) {
	if (isOpened) {
		return;
	}

	if (!backdropEl || !iframeContainerEl || !iframeEl) {
		destroy();
		create(config, options);
	}

	Dom.show(backdropEl);

	// Recenter before making visible.
	recenterIFrameContainer();
	Dom.show(iframeContainerEl);

	isOpened = true;

	emitter.emit('opened');
}

function close() {
	if (!isOpened) {
		return;
	}

	Dom.hide(iframeContainerEl);

	destroy();

	isOpened = false;

	emitter.emit('closed');
}

function setSrc(url) {
	if (iframeEl) {
		iframeEl.src = url;
	}
}

_.extend(emitter, {

	isOpened : function () { return isOpened; },

	isClosed : function () { return !isOpened; },

	open : open,

	close : close,

	setSrc : setSrc

});


module.exports = emitter;
